import * as actions from './holdings.actions';
import { Holding, HoldingsFilter } from './holdings.models';
import { DatesInterval } from '../../global/interfaces';

export interface State {
  loading: boolean;
  dates?: DatesInterval;
  data: Holding[];
  filter?: HoldingsFilter;
}

export const initialState: State = {
  loading: false,
  dates: undefined,
  data: [],
  filter: {
    year: undefined,
    month: undefined,
    allocationType: 'managerAllocations'
  }
};

export function reducer(state: State = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.ActionTypes.LOAD_HOLDINGS_DATES:
      return {
        ...state,
        loading: true,
        dates: undefined, filter: { ...state.filter, month: undefined, year: undefined }
      };
    case actions.ActionTypes.LOAD_HOLDINGS_DATES_SUCCESS:
      return { ...state, loading: false, dates: action.payload };
    case actions.ActionTypes.LOAD_HOLDINGS_DATES_FAILED:
      return { ...state, loading: false };

    case actions.ActionTypes.LOAD_HOLDINGS:
      return { ...state, loading: true };
    case actions.ActionTypes.LOAD_HOLDINGS_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case actions.ActionTypes.LOAD_HOLDINGS_FAILED:
      return { ...state, loading: false };

    case actions.ActionTypes.SET_HOLDINGS_YEAR_FILTER:
      return { ...state, filter: { ...state.filter, year: action.payload } };
    case actions.ActionTypes.SET_HOLDINGS_MONTH_FILTER:
      return { ...state, filter: { ...state.filter, month: action.payload } };

    case actions.ActionTypes.SET_HOLDINGS_ALLOCATION_TYPE:
      return { ...state, filter: { ...state.filter, allocationType: action.payload } };

    case actions.ActionTypes.RESET_HOLDINGS_DATA:
      return initialState;

    default:
      return state;
  }
}
